import { makeStyles } from '@material-ui/core/styles';

const useWizardStepCounterStyles = makeStyles({
  counter: {
    marginTop: '1.5rem', // Comes from next/back button margin + top padding (1 + ~0.5)
    display: 'flex',
    justifyContent: 'center',
    color: '#262b40',
  },
});

export default useWizardStepCounterStyles;
